// Calendar Configuration
// Update these URLs to change the calendar sources without editing code
// Use Google Calendar public iCal URLs (ending in .ics) or public calendar IDs

export const CALENDAR_CONFIG = {
  // Google Calendar sources - replace with your actual calendar URLs
  // Format: https://calendar.google.com/calendar/ical/[CALENDAR_ID]/public/basic.ics
  calendars: {
    bungee: {
      name: 'Bungee Fitness',
      // Main calendar for all classes
      icalUrl: 'https://calendar.google.com/calendar/ical/c_829d86392bcf744ae20e0a633d61efa97aa6b0ca1ec650c4b0138e0755be9a33%40group.calendar.google.com/public/basic.ics',
      color: '#FF6B35', // Orange
      bookingUrl: '/book-bungee',
      icon: 'sparkles'
    },
    aerial: {
      name: 'Aerial Kids',
      // Replace with your Aerial Kids Google Calendar iCal URL when you have a separate one
      icalUrl: '',
      color: '#9C27B0', // Purple
      bookingUrl: '/book-aerial',
      icon: 'heart'
    },
    activation: {
      name: 'Start Here / Activation',
      // Replace with your Activation Google Calendar iCal URL when you have a separate one
      icalUrl: '',
      color: '#4CAF50', // Green
      bookingUrl: '/consulting',
      icon: 'zap'
    }
  },
  
  // Default booking URLs if event doesn't specify
  defaultBookingUrls: {
    bungee: '/book-bungee',
    aerial: '/book-aerial',
    activation: '/consulting'
  },
  
  // How many days ahead to show events
  daysAhead: 60,
  
  // Enable/disable demo mode (shows sample events when no calendar URLs are configured)
  demoMode: true
};

// Sample events for demo/development (shown when calendar URLs are empty)
export const DEMO_EVENTS = [
  { date: '2026-05-03', title: 'Bungee Basics', time: '9:00 AM', type: 'bungee', bookingUrl: '/book-bungee' },
  { date: '2026-05-03', title: 'Aerial Kids Drop-In', time: '2:00 PM', type: 'aerial', bookingUrl: '/book-aerial' },
  { date: '2026-05-05', title: 'Bungee HIIT', time: '6:00 PM', type: 'bungee', bookingUrl: '/book-bungee' },
  { date: '2026-05-07', title: 'Start Here Session', time: '10:00 AM', type: 'activation', bookingUrl: '/consulting' },
  { date: '2026-05-08', title: 'Aerial Silks Class', time: '4:00 PM', type: 'aerial', bookingUrl: '/book-aerial' },
  { date: '2026-05-10', title: 'Bungee & Brunch', time: '10:00 AM', type: 'bungee', bookingUrl: '/book-bungee' },
  { date: '2026-05-10', title: 'Kids Hoop Workshop', time: '1:00 PM', type: 'aerial', bookingUrl: '/book-aerial' },
  { date: '2026-05-12', title: 'Activation Deep Dive', time: '9:00 AM', type: 'activation', bookingUrl: '/consulting' },
  { date: '2026-05-14', title: 'Bungee Dance', time: '7:00 PM', type: 'bungee', bookingUrl: '/book-bungee' },
  { date: '2026-05-15', title: 'Aerial Camp Day 1', time: '9:00 AM', type: 'aerial', bookingUrl: '/book-aerial' },
  { date: '2026-05-17', title: 'Weekend Bungee Blast', time: '10:00 AM', type: 'bungee', bookingUrl: '/book-bungee' },
  { date: '2026-05-19', title: 'Start Here Intro', time: '11:00 AM', type: 'activation', bookingUrl: '/consulting' },
  { date: '2026-05-21', title: 'Bungee Sculpt', time: '6:30 PM', type: 'bungee', bookingUrl: '/book-bungee' },
  { date: '2026-05-22', title: 'Kids Trapeze Fun', time: '3:00 PM', type: 'aerial', bookingUrl: '/book-aerial' },
  { date: '2026-05-24', title: 'Bungee Cardio Party', time: '9:00 AM', type: 'bungee', bookingUrl: '/book-bungee' },
  { date: '2026-05-26', title: 'Aerial Open Practice', time: '4:00 PM', type: 'aerial', bookingUrl: '/book-aerial' },
  { date: '2026-05-28', title: 'Activation Workshop', time: '10:00 AM', type: 'activation', bookingUrl: '/consulting' },
  { date: '2026-05-31', title: 'Memorial Day Bungee', time: '9:00 AM', type: 'bungee', bookingUrl: '/book-bungee' },
];

export default CALENDAR_CONFIG;
